import Styles from "../../../styles/report/mobile/notesmobile.module.scss";

const ReportNotesMobile = ({ report }) => {
// Sort by block and map by block number
  const sortedReports = Array.isArray(report)
    ? [...report].sort(
        (a, b) =>
          (a?.block ?? Number.MAX_SAFE_INTEGER) -
          (b?.block ?? Number.MAX_SAFE_INTEGER)
      )
    : [];

  const reportsByBlock = new Map(
    sortedReports
      .filter((r) => Number.isFinite(r?.block))
      .map((r) => [r.block, r])
  );

  // Always render 4 blocks; fill missing with empty string
  const notesData = Array.from({ length: 4 }, (_, i) => {
    const block = i + 1;
    const r = reportsByBlock.get(block);
    return { quarter: block, notes: r?.notes || "" };
  });


  return (
    <div className={Styles.notesContainer}>
      <h2 className={Styles.title}>Notes</h2>
      <div className={Styles.notesTable}>
        <div className={Styles.header}>
          <div className={Styles.quarterHeader}>Blocks</div>
          <div className={Styles.notesHeader}>Notes</div>
        </div>
        {notesData.map((item) => (
          <div key={item.quarter} className={Styles.noteRow}>
            <div className={Styles.quarter}>{item.quarter}</div>
            <div className={Styles.notes}>{item.notes}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportNotesMobile;
